import React, { useRef, useState, useEffect, useCallback } from 'react';
import './clientDashboardMap.css';
import ClientNavbar from '../client-dashboard/clientNavbar/clientNavbar';
import PortalHeader from '../client-dashboard/clientNavbar/PortalHeader';
import LoadingSpinner from '../backend/components/LoadingSpinner'; // Import the loading spinner
import LoadingBar from '../backend/components/LoadingBar';
import { toast, ToastContainer } from 'react-toastify'; // Import ToastContainer
import 'react-toastify/dist/ReactToastify.css';

// import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
// import Map from '../components/map';

// Assets
import googleMapsLogo from '../backend/assets/google-map-logo.png'
import fnnPopupLogo from '../img/detector/2025Detector4.jpg'
import greenMarker from './client-dashboard-assets/mapdetectoricon-blue.png'
import offlineMarker from './client-dashboard-assets/mapdetectoricon-grey.png'

// Map functionality and Design imports
import GradientLegend, { interpolateColor } from "./cilent-dashboard-util/GradientLegend";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    useMap,
    GeoJSON
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/dist/styles.min.css";
import { Icon } from "leaflet";
import L, { LeafletEvent, GeoJSON as LeafletGeoJSON } from "leaflet";
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import "leaflet-geosearch/dist/geosearch.css";
// import detectorData from './fake-detectors.json'
import generateLightningData from './lightningData';

// ------------- Popup imports -------------
import Modal from "../components/UtilComponents/Modal";
import { useAuth } from '../Auth';
// ------------- Popup imports -------------

import { HeatMapLayer, heatMapData } from './HeatMapMap'

// CSRF imports
import Cookies from 'universal-cookie';
const cookies = new Cookies();

// Icons
import { TbCalendarPlus } from "react-icons/tb";
import { MdOutlineEditCalendar } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";

// Define the Detector type for TypeScript
interface Detector {
    ip: string
    last_active: string
    mac: string
    online: boolean
    status: {
        fw_version: any
        gps_fix: boolean
        gps_lat: any
        gps_long: any
        linux: boolean
        memory: number
        site_name: string
        test_mode: boolean
        thr: any
        up_since: string
    }
}

interface DetectorObject {
    name: string
    receiver: string
}

// Interface for reading image
interface DetectorPhoto {
    IMAGE_ID: number;
    DETECTOR_ID: string;
    DETECTOR_SITE_NAME: string;
    DETECTOR_IMG: any;
    organization?: number;
}

// Interface for reading notes
interface DetectorNotes {
    NOTE_ID?: number, // optional when creating
    DETECTOR_ID: string,
    NOTE_TITLE: string,
    NOTE_SUBMIT_DATE: string,
    NOTE_EDIT_DATE: any,
    NOTE_BODY: string,
    organization?: number
}

// Helper function to normalize MAC addresses
function normalizeMac(mac: string): string {
    return mac?.toLowerCase().replace(/^(0x|000)/, "") || "";
}

export const BwIcon = new Icon({
    iconUrl: offlineMarker,
    iconSize: [50, 50]
});

export const greenIcon = new Icon({
    iconUrl: greenMarker,
    iconSize: [50, 50]
});

interface CenterMapOnDetectorProps {
    latitude: number;
    longitude: number;
    zoomLevel: number;
}

const getTodayDateString = (): string => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // Format: "YYYY-MM-DD"
};

/* ---------------- Functions for determining the range colors based on the lightning count START ---------------- */

const getColorForMarker = (isOn: boolean) => {
    if (isOn === false) return BwIcon;
    return greenIcon; //green
};

function getMinMaxDensity(data: any | null) {
    if (!data) return { min: 0, max: 0 }; // Handle null case safely

    const features = (data as GeoJSON.FeatureCollection).features; // Ensure correct type
    const densities = features
        .map((feature) => feature.properties?.density) // Use optional chaining to avoid null errors
        .filter((density): density is number => density !== undefined && density !== null); // Filter out undefined/null values

    // console.log(Math.min(...densities), Math.max(...densities))

    if (densities.length === 0) return { min: 0, max: 0 }; // Handle empty array case

    return {
        min: Math.min(...densities),
        max: Math.max(...densities),
    };
}

function style(feature: any, min: number, max: number) {
    const fillColor = interpolateColor(feature.properties.density, min, max).color;

    return {
        fillColor: 'transparent',
        weight: 2, // Thin border
        opacity: 0.8, // Slight opacity on border
        color: 'transparent', // Transparent border color
        dashArray: '3', // Optional dashed effect
        fillOpacity: 0.6, // Slight opacity for fill
        // Create a subtle "fuzzy" border by applying a shadow
        // with a slight blur to make the transitions smoother
        shadowBlur: 4, // Adjust this for smoothness (bigger = smoother)
        shadowColor: fillColor, // Same color as fill
        shadowOpacity: 0.3, // Make the shadow subtle
    };
}

// function style(feature: any, min: number, max: number) {
//     return {
//         fillColor: interpolateColor(feature.properties.density, min, max).color,
//         weight: 2,
//         opacity: 1,
//         color: 'transparent',
//         dashArray: '3',
//         fillOpacity: 0.4
//     };
// }

interface Result {
    lon: string;
    lat: string;
    display_name: string;
    boundingbox: string[];
}

const DjangoNominatimProvider = {
    search: (() => {
        let timeout: NodeJS.Timeout | null = null;
        let controller: AbortController | null = null;

        return ({ query }: { query: string }) => {
            if (!query) return Promise.resolve([]);

            if (controller) controller.abort();
            if (timeout) clearTimeout(timeout);

            return new Promise((resolve, reject) => {
                timeout = setTimeout(() => {
                    controller = new AbortController();

                    fetch(`/api/geocode?q=${encodeURIComponent(query)}`, {
                        signal: controller.signal,
                    })
                        .then((response) => response.json())
                        .then((results: Result[]) => {
                            resolve(
                                results.map((r) => ({
                                    x: parseFloat(r.lon),
                                    y: parseFloat(r.lat),
                                    label: r.display_name,
                                    bounds: [
                                        [parseFloat(r.boundingbox[0]), parseFloat(r.boundingbox[2])],
                                        [parseFloat(r.boundingbox[1]), parseFloat(r.boundingbox[3])],
                                    ],
                                    raw: r,
                                }))
                            );
                        })
                        .catch((e) => {
                            if ((e as any).name === "AbortError") return;
                            reject(e);
                        });
                }, 200);
            });
        };
    })(),
};

const SearchControl: React.FC = () => {
    const map = useMap();

    useEffect(() => {
        const searchControl = new (GeoSearchControl as any)({
            provider: DjangoNominatimProvider,
            style: "bar",
            showMarker: false,
            showPopup: true,
            popupFormat: ({ query, result }: { query: string; result: { label: string } }) =>
                `You searched for: ${query}<br>Result: ${result.label}`,
            searchLabel: "Search Address or Zip",
        });

        map.addControl(searchControl);

        return () => {
            map.removeControl(searchControl);
        };
    }, [map]);

    return null;
};


// const CenterMapOnDetector: React.FC<CenterMapOnDetectorProps> = ({ latitude, longitude, zoomLevel }) => {
//     const map = useMap();

//     useEffect(() => {
//         if (latitude && longitude) {
//             map.flyTo([latitude, longitude], zoomLevel, {
//                 duration: 1.5,
//             });
//         }
//     }, [latitude, longitude, zoomLevel, map]);

//     return null;
// };

const CenterMapOnDetector2: React.FC<CenterMapOnDetectorProps> = ({ latitude, longitude, zoomLevel }) => {
    const map = useMap();

    useEffect(() => {
        if (latitude && longitude) {
            const startZoom = map.getZoom();
            const startLatLng = map.getCenter();
            const startTime = performance.now();
            const duration = 500; // 1.5 seconds animation

            const animate = (timestamp: number) => {
                const elapsed = timestamp - startTime;
                const t = Math.min(elapsed / duration, 1); // Ensure t is between 0 and 1

                const newLat = startLatLng.lat + (latitude - startLatLng.lat) * t;
                const newLng = startLatLng.lng + (longitude - startLatLng.lng) * t;
                const newZoom = startZoom + (zoomLevel - startZoom) * t;

                map.setView([newLat, newLng], newZoom, { animate: false });

                if (t < 1) {
                    requestAnimationFrame(animate);
                }
            };

            requestAnimationFrame(animate);
        }
    }, [latitude, longitude, zoomLevel, map]);

    return null;
};

const FetchingLightningData = () => {
    const [statesData, setStatesData] = useState<GeoJSON.GeoJsonObject | null>(null);
    const [isGeoJsonLoaded, setIsGeoJsonLoaded] = useState(false);

    const fetchData = async () => {
        const data = await generateLightningData(); // Your function to get lightning data
        setStatesData(data);
        setIsGeoJsonLoaded(true); // Set it to true once GeoJSON is loaded
    };

    useEffect(() => {
        fetchData(); // Initial data fetch when the component mounts

        // Reload the data every 5 seconds
        const intervalId = setInterval(fetchData, 10000);

        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []);

    return { statesData, isGeoJsonLoaded };
};


/* ---------------- Functions for determining the range colors based on the lightning count END ---------------- */

const ClientDashboardMapNew = () => {

    // Refresh in case group changes
    useEffect(() => {
        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === "selectedGroup") {
                // If the selectedGroup changes in localStorage, refresh the page
                window.location.reload();
            }
        };

        // Listen for changes in localStorage
        window.addEventListener("storage", handleStorageChange);

        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    const [heatmapData, setHeatmapData] = useState<any>([]);
    const [min2, setMin2] = useState<any>(null);
    const [max2, setMax2] = useState<any>(null);

    // Function to load data
    const loadData = async () => {
        const data = await heatMapData();
        setHeatmapData(data);
    };

    useEffect(() => {
        // Load data initially
        loadData();

        // Set interval to load data every 5 seconds
        const intervalId = setInterval(() => {
            loadData();
        }, 10000); // 5000ms = 5 seconds

        // Clean up interval on component unmount
        return () => clearInterval(intervalId);
    }, []); // Empty dependency array ensures this runs only once on mount

    const handleExtremaChange = (newMin: number, newMax: number) => {
        setMin2(newMin);
        setMax2(newMax);
    };

    // Region selection dropdown



    // --------------------------------------------- Popup START ---------------------------------------------
    const { isAuthenticated, getDashboardPermissions, organization_id, organization_permissions } = useAuth();
    const hasFieldTechPermission = organization_permissions?.includes("Field Tech");
    const [clientPermissionGroups, setClientPermissionGroups] = useState<{ [key: string]: any }>({});

    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [groups, setGroups] = useState<string[]>([]);
    const [chosenGroupCallback, setChosenGroupCallback] = useState<((groupName: string) => void) | null>(null);
    const [savedGroup, setSavedGroup] = useState<string | null>(localStorage.getItem("selectedGroup"));
    const popupRefs = useRef<Record<string, L.Popup>>({});

    const tempName = Object.keys(clientPermissionGroups).filter(groupName => clientPermissionGroups[groupName]);

    useEffect(() => {
        const fetchClientPermissions = async () => {
            const permissions2 = await getDashboardPermissions(); // Await the promise
            setClientPermissionGroups(permissions2 || {});

            // Return a promise that resolves when a group is selected
            return new Promise((resolve) => {
                setChosenGroupCallback(() => (selectedGroup: string) => {
                    setModalOpen(false); // Close the modal
                    localStorage.setItem("selectedGroup", selectedGroup); // Save to local storage
                    resolve(selectedGroup); // Resolve the promise with the selected group
                });
            });
        };

        if (isAuthenticated) {
            fetchClientPermissions();
        }
    }, [isAuthenticated, getDashboardPermissions]);

    useEffect(() => {
        if (!savedGroup && clientPermissionGroups && Object.keys(clientPermissionGroups).length > 1) {
            // Extract the group names with a true value
            const groupNames = Object.keys(clientPermissionGroups).filter(groupName => clientPermissionGroups[groupName]);

            // Set the popup to open and assign the name of the buttons based on the names of the read groups
            setGroups(groupNames);
            setModalOpen(true);
        }

        if (clientPermissionGroups && Object.keys(clientPermissionGroups).length === 1) {
            // Extract the group name with a true value
            const firstGroup = Object.entries(clientPermissionGroups)[0]; // Get the first key-value pair

            // Check if the user has access to that specified table
            if (firstGroup[1] === true) {
                handleFunction(firstGroup[0]);
            } else {
                console.warn("This user does not have permission to access this table");
            }
        }
    }, [clientPermissionGroups, savedGroup]); // Runs after `clientPermissionGroups` updates

    // Check localStorage for selected group whenever savedGroup or groups change
    useEffect(() => {
        const storedGroup = localStorage.getItem("selectedGroup");

        // Ensure that groups is populated before performing the check
        if (groups.length === 0) {
            return; // Don't proceed until groups are populated
        }

        if (storedGroup && !groups.includes(storedGroup)) {
            console.warn(`The selected group "${storedGroup}" is not valid.`);
            localStorage.setItem("selectedGroup", groups[0]); // Save to local storage
            return; // Exit early after redirect
        }

        // If the stored group is valid, set it to state
        setSavedGroup(storedGroup);
    }, [groups]); // Runs when `groups` changes


    const handleFunction = (selectedGroup: string) => {
        if (chosenGroupCallback) {
            chosenGroupCallback(selectedGroup); // Trigger the callback with the selected group
            localStorage.setItem("selectedGroup", selectedGroup);

            if (clientPermissionGroups && Object.keys(clientPermissionGroups).length > 1) {
                window.location.reload();
            }
            setSavedGroup(selectedGroup); // Update the state with the selected group
        }
    };

    // --------------------------------------------- Popup END ---------------------------------------------



    const { statesData, isGeoJsonLoaded } = FetchingLightningData(); // Fetching data here
    const { min, max } = getMinMaxDensity(statesData);

    /* ------------------------ FUNCTIONS TO DETERMINE HOVER ANIMATION ON LIGHTNING COUNT ------------------------ */
    const geojsonRef = useRef<L.GeoJSON | null>(null); // Create a reference for the GeoJSON layer
    const [hoveredFeature, setHoveredFeature] = useState<{ name: string; density: number } | null>(null);


    function highlightFeature(e: LeafletEvent) {
        const layer = e.target as L.Path; // Cast to Leaflet Path for setStyle

        layer.setStyle({
            weight: 5,
            color: "#666",
            dashArray: "",
            fillOpacity: 0.5,
        });

        layer.bringToFront();
    }

    // Reset highlight on mouseout
    function resetHighlight(e: LeafletEvent) {
        if (geojsonRef.current) {
            geojsonRef.current.resetStyle(e.target);
        }
    }

    useEffect(() => {
        if (geojsonRef.current && statesData) {
            // Clear the previous GeoJSON layer
            geojsonRef.current.clearLayers();

            // Add the new GeoJSON layer with the updated data
            geojsonRef.current.addData(statesData);
        }
    }, [statesData]); // This effect will run every time `statesData` changes

    // Zoom to feature on click with some padding
    function zoomToFeature(e: LeafletEvent) {
        const map = e.target._map;
    }

    // Function to handle each GeoJSON feature
    function onEachFeature(feature: GeoJSON.Feature, layer: L.Layer) {
        layer.on({
            mouseover: (e: LeafletEvent) => {
                const layer = e.target as L.Path;
                highlightFeature(e);

                if (feature.properties) {
                    setHoveredFeature({
                        name: feature.properties.name,
                        density: feature.properties.density
                    });
                }
            },
            mouseout: (e: LeafletEvent) => {
                resetHighlight(e);
                setHoveredFeature(null); // Clear the hovered data when the mouse leaves
            },

            click: zoomToFeature,
        });
    }

    const computedStyle = useCallback((feature: any) => style(feature, min, max), [min, max]);


    /* ------------------------ FUNCTIONS TO DETERMINE HOVER ANIMATION ON LIGHTNING COUNT ------------------------ */

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 7000); // 7 seconds

        return () => clearTimeout(timer); // Cleanup timer on unmount
    }, []);

    const [loadingLightning, setLoadingLightning] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoadingLightning(false);
        }, 10000); // 7 seconds

        return () => clearTimeout(timer); // Cleanup timer on unmount
    }, []);

    // --------------------------------------------- Getting MAC from new API START ---------------------------------------------
    const [macsFromAPI, setMacsFromAPI] = useState<Detector[]>([]);
    const [detectorJson, setDetectorJson] = useState<Detector[]>([]); // Initialize with empty array or macsFromAPI
    const [isMapReady, setIsMapReady] = useState(false); // State to track if the map can be rendered
    const [macsFromTailscale, setMacsFromTailscale] = useState<DetectorObject[]>([]);

    const fetchMACsFromAPI = async (selectedGroup: string | null) => {
        try {
            if (!selectedGroup) return; // Prevent fetch if no group is selected

            const response = await fetch(`/apidet/${selectedGroup}/`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "same-origin",
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: Detector[] = await response.json();
            setMacsFromAPI(data); // Assign the fetched data to state
        } catch (err) {
            if (err instanceof Error) {
                console.error(err.message);
            } else {
                console.error('An unknown error occurred');
            }
        }
    };

    // Fetch on initial load and then every 5 seconds
    useEffect(() => {
        if (savedGroup) {
            fetchMACsFromAPI(savedGroup);

            const interval = setInterval(() => {
                fetchMACsFromAPI(savedGroup);
            }, 5000); // 5000 ms = 5 seconds

            // Clear interval on component unmount or when group changes
            return () => clearInterval(interval);
        }
    }, [savedGroup]); // Runs when savedGroup changes

    // Whenever macsFromAPI changes, update detectorJson
    useEffect(() => {
        setDetectorJson(macsFromAPI); // Sync macsFromAPI with detectorJson
    }, [macsFromAPI]);

    // Whenever macsFromAPI changes, update detectorJson
    useEffect(() => {
        setDetectorJson(macsFromAPI); // Sync macsFromAPI with detectorJson

        // Check if a valid detector with coordinates exists
        const validDetector = Object.values(macsFromAPI).find(
            (detector) => detector.status?.gps_lat && detector.status?.gps_long
        );

        // If a valid detector is found, set isMapReady to true
        if (validDetector) {
            setIsMapReady(true);
        }

    }, [macsFromAPI]);

    // Fetching tailscale for naming parameters
    const fetchMACsFromTailscale = async () => {
        try {
            const response = await fetch(`/portal/api/relay_fnn_network_basic/`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "same-origin",
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: DetectorObject[] = await response.json();
            setMacsFromTailscale(data); // Assign the fetched data to state
        } catch (err) {
            if (err instanceof Error) {
                console.error(err.message);
            } else {
                console.error('Error fetching tailscale data');
            }
        }
    };

    useEffect(() => {
        fetchMACsFromTailscale();
    }, []); // Empty dependency array to run once on mount

    const getDetectorName = (mac: string, tailscaleDevices: DetectorObject[]): string => {
        const match = tailscaleDevices.find(
            (d) => normalizeMac(d.receiver) === normalizeMac(mac)
        );

        if (!match) return mac; // fallback to mac if no match

        // Split "ThisIsATestName" → "This Is A Test Name"
        return match.name.replace(/([A-Z])/g, ' $1').trim();
    };

    const validDetector = Object.values(detectorJson).find(
        (detector) => {
            const lat = Number(detector.status?.gps_lat);
            const long = Number(detector.status?.gps_long);
            return lat !== 0 && long !== 0;
        }
    );

    // Provide default coordinates if validDetector is undefined
    const center: [number, number] = validDetector?.status?.gps_lat && validDetector?.status?.gps_long
        ? [Number(validDetector.status.gps_lat), Number(validDetector.status.gps_long)]
        : [37.7749, -122.4194]; // Fallback to San Francisco



    // --------------------------------------------- Getting MAC from new API END ---------------------------------------------

    // State to control visibility of the form
    const [isFormVisible, setFormVisible] = useState(true);
    const [isArrowVisible, setArrowVisible] = useState(false);
    const [isUserToggled, setUserToggled] = useState(false); // Track manual toggling of the form

    // Create a reference for the form wrapper for making it visible/hidden based on the button clicked
    const formWrapperRef = useRef(null);

    // Function for toggling the dashboard menu when on mobile
    const handleToggleForm = () => {
        setFormVisible((prev) => !prev);
        setUserToggled((prev) => !prev);
    };

    // Making the arrow to use the menu pop up when the user is on mobile
    // Runs only when window resizes
    useEffect(() => {
        const handleResize = () => {
            // Only auto-adjust visibility if user hasn't manually toggled
            if (!isUserToggled) {
                if (window.innerWidth < 765) {
                    setFormVisible(false);
                } else {
                    setFormVisible(true);
                }
            }

            // Arrow should always be visible regardless of screen size
            setArrowVisible(true);

            // Optional: update CSS vars
            const arrowBottomPosition = isFormVisible ? '97%' : '-2%';
            const zIndex = isFormVisible ? '2' : '0';
            document.documentElement.style.setProperty('--arrow-bottom-position', arrowBottomPosition);
            document.documentElement.style.setProperty('--z-index', zIndex);
        };

        handleResize(); // run once on mount
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isUserToggled, isFormVisible]); // also depends on isFormVisible for CSS updates

    const markerRefs = useRef<{ [key: string]: any }>({}); // Refs for markers

    // Variable to center the zoom on the detector
    const [centerCoordinates, setCenterCoordinates] = useState<{ latitude: number; longitude: number } | null>(null);

    // const detectorArray: DetectorObject[] = Object.values(detectorData);

    // Function to open popup for a specific detector
    const openPopup = (detectorId: string) => {
        const detector = Object.values(detectorJson).find(
            (det) => det.mac === detectorId
        );

        if (detector && markerRefs.current[detectorId]) {
            const latitude = Number(detector.status.gps_lat)
            const longitude = Number(detector.status.gps_long)

            markerRefs.current[detectorId].openPopup();
            // Temporarily reset centerCoordinates to force re-render
            setCenterCoordinates(null);
            setTimeout(() => {
                setCenterCoordinates({ latitude, longitude });
            }, 0); // Small delay to allow React to reset
        }
    };

    // Separate detectors into online and offline groups
    const onlineDetectors = Object.values(detectorJson).filter((detector) => detector.online === true);
    const offlineDetectors = Object.values(detectorJson).filter((detector) => detector.online === false);

    // Search variables and funtions
    const [searchTerm, setSearchTerm] = useState<string>(""); // State to store the search term

    // Function to handle search input changes
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setSearchTerm(e.target.value.toLowerCase()); // Update search term and convert to lowercase for case-insensitive matching
    };

    // Filter the detectors based on the search term
    const filteredOnlineDetectors = onlineDetectors.filter((detector) => {
        const name = getDetectorName(detector.mac, macsFromTailscale).toLowerCase();
        return name.includes(searchTerm);
    });

    const filteredOfflineDetectors = offlineDetectors.filter((detector) => {
        const name = getDetectorName(detector.mac, macsFromTailscale).toLowerCase();
        return name.includes(searchTerm);
    });

    // Fetching detector images
    const [galleryData, setGalleryData] = useState<DetectorPhoto[]>([]);

    const fetchGalleryPhotos = async () => {
        try {
            const response = await fetch('/api/detectordashimgs', {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'same-origin',
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: DetectorPhoto[] = await response.json();
            setGalleryData(data); // Assign the fetched gallery data to state
            // console.log(data)

        } catch (err) {
            // Type assertion to 'Error' to access the message property
            if (err instanceof Error) {
                console.error(err.message); // Handle error
            } else {
                console.error('An unknown error occurred'); // Fallback for unknown errors
            }
        }
    };

    useEffect(() => {
        fetchGalleryPhotos();
    },
        []); // Empty dependency array to run once on mount

    const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);
    const [previewURL, setPreviewURL] = useState<string | null>(null);

    const handleImageUpload = async () => {
        if (!selectedImageFile || !selectedDetector) return;

        const formData = new FormData();
        formData.append("DETECTOR_ID", selectedDetector.mac);
        formData.append("DETECTOR_SITE_NAME", selectedDetector.status.site_name || selectedDetector.mac);
        formData.append("DETECTOR_IMG", selectedImageFile);
        formData.append("organization", String(organization_id));

        try {
            const csrfToken = cookies.get('csrftoken') || getCsrfToken();

            const existing = galleryData.find((img) => {
                return img.DETECTOR_ID === selectedDetector.mac && img.organization === organization_id;
            });


            const method = existing ? 'PUT' : 'POST';
            const endpoint = existing
                ? `/api/detectordashimgs/${existing.IMAGE_ID}/`
                : `/api/detectordashimgs/`;

            const response = await fetch(endpoint, {
                method,
                headers: {
                    'X-CSRFToken': csrfToken,
                },
                credentials: 'same-origin',
                body: formData,
            });

            if (!response.ok) {
                const errText = await response.text();
                throw new Error(`Upload failed: ${response.status} - ${errText}`);
            }

            toast.success('Image uploaded successfully!', {
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                style: {
                    backgroundColor: '#2d2f31',
                    color: 'white',
                    fontSize: '16px',
                }
            });

            setPreviewURL(null); // Clear preview after upload
            setSelectedImageFile(null);
            fetchGalleryPhotos(); // Refresh gallery
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    // Displaying popup that will handle image upload
    const [showDetecPopup, setShowDetecPopup] = useState(false);
    const [selectedDetector, setSelectedDetector] = useState<Detector | null>(null);
    const [showNotesPopup, setShowNotesPopup] = useState(false);

    // Notes logic
    // State to control visibility of the form
    const [isNotesFormVisible, setNotesFormVisible] = useState(false);
    const formRef = useRef<HTMLDivElement | null>(null);
    const [listOfNotes, setListOfNotes] = useState<DetectorNotes[]>([]);
    const [noteBeingEdited, setNoteBeingEdited] = useState<DetectorNotes | null>(null);
    const [editTitle, setEditTitle] = useState('');
    const [editBody, setEditBody] = useState('');


    const getCsrfToken = (): string | null => {
        const metaTag = document.querySelector('meta[name="csrf-token"]');
        return metaTag ? metaTag.getAttribute('content') : null; // Return null if the meta tag is not found
    };

    const fetchCsrfToken = async () => {
        const response = await fetch('/api/csrf-token/', {
            method: 'GET',
            credentials: 'same-origin', // include cookies in the request
        });

        if (response.ok) {
            const data = await response.json();
            return data.csrfToken; // Return the CSRF token
        } else {
            console.error('Failed to fetch CSRF token');
            return null;
        }
    };

    const fetchNotes = async () => {
        try {
            const response = await fetch('/api/detectordashnotes/', {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "same-origin",
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: DetectorNotes[] = await response.json();
            setListOfNotes(data); // Assign the fetched gallery data to state
            // console.log(data)

        } catch (err) {
            // Type assertion to 'Error' to access the message property
            if (err instanceof Error) {
                console.error(err.message); // Handle error
            } else {
                console.error('An unknown error occurred'); // Fallback for unknown errors
            }
        }
    };

    const createNewRowInDB = async (myNotes: DetectorNotes) => {
        try {

            let csrfToken = cookies.get('csrftoken'); // Get the CSRF token from cookies

            if (!csrfToken) {
                csrfToken = getCsrfToken(); // ✅ csrfToken = getCsrfToken();
                if (!csrfToken) {
                    console.error('CSRF token not found');
                    return; // Handle the absence of the CSRF token appropriately
                }
            }

            // Exclude NOTE_ID from the body before sending
            const { NOTE_ID, ...noteWithoutID } = myNotes;

            const noteToSend = {
                ...noteWithoutID,
                organization: organization_id,  // ✅ Send integer ID now
            };

            // Check if an item with the given DETECTOR_ID exists in galleryData
            const response = await fetch(`/api/detectordashnotes/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                credentials: 'same-origin',
                body: JSON.stringify(noteToSend)
            });


            if (!response.ok) {
                const errorText = await response.text(); // Fetch response body for more details
                throw new Error(`Server error: ${response.status} - ${errorText}`);
            }

            await response.json();
            // const result = await response.json();
            // console.table(result.value);


        } catch (err) {
            // Type assertion to 'Error' to access the message property
            if (err instanceof Error) {
                console.error(err.message); // Handle error
            } else {
                console.error('An unknown error occurred'); // Fallback for unknown errors
            }
        }

        fetchNotes();
    };

    const deleteRowFromDB = async (noteID: number) => {
        try {

            let csrfToken = cookies.get('csrftoken'); // Get the CSRF token from cookies

            if (!csrfToken) {
                csrfToken = getCsrfToken(); // ✅ csrfToken = getCsrfToken();
                if (!csrfToken) {
                    console.error('CSRF token not found');
                    return; // Handle the absence of the CSRF token appropriately
                }
            }

            const response = await fetch(`/api/detectordashnotes/${noteID}`, {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                credentials: 'same-origin',
            });

            if (!response.ok) {
                const errorText = await response.text(); // Fetch response body for more details
                throw new Error(`Server error: ${response.status} - ${errorText}`);
            }

            // Only attempt to parse JSON if there's content
            if (response.headers.get("content-length") !== "0") {
                await response.json();
            }

        } catch (err) {
            if (err instanceof Error) {
                console.error(err.message);
            } else {
                console.error("An unknown error occurred");
            }
        }

        fetchNotes();
    };

    const updateRowInDB = async (noteID: number, myNotes: DetectorNotes) => {
        try {

            let csrfToken = cookies.get('csrftoken'); // Get the CSRF token from cookies

            if (!csrfToken) {
                csrfToken = getCsrfToken(); // ✅ csrfToken = getCsrfToken();
                if (!csrfToken) {
                    console.error('CSRF token not found');
                    return; // Handle the absence of the CSRF token appropriately
                }
            }

            const updatedNoteWithOrg = {
                ...myNotes,
                organization: organization_id,
            };

            const response = await fetch(`/api/detectordashnotes/${noteID}/`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                credentials: 'same-origin',
                body: JSON.stringify(updatedNoteWithOrg)
            });

            if (!response.ok) {
                const errorText = await response.text(); // Fetch response body for more details
                throw new Error(`Server error: ${response.status} - ${errorText}`);
            }

            // Only attempt to parse JSON if there's content
            if (response.headers.get("content-length") !== "0") {
                await response.json();
            }

        } catch (err) {
            if (err instanceof Error) {
                console.error(err.message);
            } else {
                console.error("An unknown error occurred");
            }
        }

        fetchNotes();
    };

    useEffect(() => {
        fetchNotes();
    },
        []); // Empty dependency array to run once on mount


    listOfNotes.sort((a, b) => {
        const dateDiff = new Date(b.NOTE_SUBMIT_DATE).getTime() - new Date(a.NOTE_SUBMIT_DATE).getTime();

        // If dates are the same, sort by NOTE_ID in descending order
        if (dateDiff === 0) {
            return b.NOTE_ID! - a.NOTE_ID!;
        }

        return dateDiff;
    });

    // Closing smaller popup when 
    const handleCloseBigPopup = () => {
        setShowDetecPopup(false);
        setShowNotesPopup(false);

        // Also close the leaflet popup for the selected detector
        if (selectedDetector?.mac) {
            const popup = popupRefs.current[selectedDetector.mac];
            if (popup) {
                popup.remove(); // This will safely remove the popup from the map
            }
        }

        setSelectedDetector(null);
        setPreviewURL(null);
    };

    useEffect(() => {
        const repositionArrow = () => {
            if (!isFormVisible) return;

            const dash = document.querySelector('.my-dash') as HTMLElement | null;
            const arrow = document.querySelector('.circle-around-arrow') as HTMLElement | null;

            if (dash && arrow) {
                const dashRect = dash.getBoundingClientRect();
                arrow.style.bottom = `${dashRect.height + 12}px`; // 16px for spacing
            }
        };

        repositionArrow();
        window.addEventListener('resize', repositionArrow);

        return () => window.removeEventListener('resize', repositionArrow);
    }, [isFormVisible]);

    return (
        <div style={{ width: "100%", height: "100%" }}> {/* Ensure it has a height */}

            {/* <ClientNavbar setSavedGroup={setSavedGroup} groupCount={Object.keys(clientPermissionGroups).length} /> */}
            <PortalHeader />

            <ToastContainer /> {/* Handle toasts in this page */}

            {modalOpen &&
                <Modal
                    popupTitle={"Select Region"}
                    setOpenModal={setModalOpen}
                    functionToExecute={handleFunction}
                    groupNames={groups}
                />}

            <div className="map-and-dash">
                {isMapReady ? (
                    <>
                        {hoveredFeature && (
                            <div
                                className={`lightning-info ${!isFormVisible ? 'dash-hidden' : ''}`}
                            >
                                <div className="hover-info">
                                    <p>Strikes: <br />{hoveredFeature.density}⚡</p>
                                </div>
                            </div>
                        )}

                        {(min2 >= 0 && max2 > 0) ? (
                            <div
                                className={`lightning-info-legend ${!isFormVisible ? 'dash-hidden' : ''}`}
                            >
                                <div className="lightning-info-legend-inner">
                                    <GradientLegend min={1} max={max2} />
                                </div>
                            </div>

                        ) : (
                            <div
                                className={`lightning-info-legend ${!isFormVisible ? 'dash-hidden' : ''}`}
                            >
                                {loading ? <LoadingBar />
                                    :
                                    <div className='no-lightning-data'>
                                        <p>No⚡data in this region.</p>
                                    </div>}
                            </div>
                        )}

                        <div className="my-map">
                            <MapContainer
                                center={center}
                                zoom={9}
                                minZoom={2}  // Set the minimum zoom level
                                style={{ width: "100%", height: "100%" }} // Ensure the map takes up the full container
                            >
                                {/* Add a TileLayer to display map tiles */}
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                />

                                {/* Add the heatmap layer */}
                                <HeatMapLayer data={heatmapData} onExtremaChange={handleExtremaChange} />

                                {/* Add the search control */}

                                <SearchControl />

                                {centerCoordinates && (
                                    <CenterMapOnDetector2
                                        latitude={centerCoordinates.latitude}
                                        longitude={centerCoordinates.longitude}
                                        zoomLevel={9} // Specify the desired zoom level
                                    />
                                )}

                                {/* Conditionally render GeoJSON layer when statesData is available */}
                                {isGeoJsonLoaded && statesData && (
                                    <GeoJSON
                                        data={statesData as GeoJSON.GeoJsonObject}
                                        style={computedStyle}
                                        onEachFeature={onEachFeature} // Attach event handlers
                                        ref={geojsonRef} // Assign reference to the GeoJSON layer
                                    />
                                )}

                                {Object.values(detectorJson).map((currentDetector) => {
                                    if (
                                        currentDetector &&
                                        currentDetector.status &&
                                        Object.keys(currentDetector.status).length > 0 && // Ensure status is not empty
                                        currentDetector.status.gps_lat !== null &&
                                        currentDetector.status.gps_long !== null &&
                                        Math.abs(Number(currentDetector.status.gps_lat)) > 1e-6 &&
                                        Math.abs(Number(currentDetector.status.gps_long)) > 1e-6
                                    ) {
                                        return (
                                            <Marker
                                                key={currentDetector.mac}
                                                position={[
                                                    Number(currentDetector.status.gps_lat),
                                                    Number(currentDetector.status.gps_long),
                                                ]}
                                                icon={getColorForMarker(currentDetector.online)}
                                                ref={(el) => (markerRefs.current[currentDetector.mac] = el)}
                                            >
                                                <Popup
                                                    ref={(popup) => {
                                                        if (popup) {
                                                            popupRefs.current[currentDetector.mac] = popup;
                                                        }
                                                    }}>
                                                    <div
                                                        onClick={() => {
                                                            setSelectedDetector(currentDetector);
                                                            setShowDetecPopup(true);
                                                        }}
                                                        style={{ cursor: 'pointer', width: '100%' }}
                                                    >

                                                        <img
                                                            src={
                                                                (galleryData.find(photo => photo.DETECTOR_ID === currentDetector.mac)?.DETECTOR_IMG) ||
                                                                fnnPopupLogo
                                                            }
                                                            alt=""
                                                            className="fnn-popup-logo"
                                                        />

                                                        <div className='new-popup-content'>
                                                            <p>
                                                                <strong>Detector:</strong>{" "}
                                                                <span style={{ color: '#28aee1' }}>
                                                                    {getDetectorName(currentDetector.mac, macsFromTailscale)}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <strong>Status:</strong>{" "}
                                                                <span style={{ color: currentDetector.online ? 'green' : 'red' }}>
                                                                    {currentDetector.online ? 'Online' : 'Offline'}
                                                                </span>
                                                            </p>
                                                            <p><strong>Latitude:</strong> {currentDetector.status.gps_lat}</p>
                                                            <p><strong>Longitude:</strong> {currentDetector.status.gps_long}</p>

                                                            {hasFieldTechPermission && (
                                                                <>
                                                                    <p>
                                                                        <strong>GPS Fix:</strong>{" "}
                                                                        <span style={{ color: currentDetector.status.gps_fix ? 'green' : 'red' }}>
                                                                            {currentDetector.status.gps_fix === true ? "Yes" : "No"}
                                                                        </span>
                                                                    </p>

                                                                    <div
                                                                        className='google-maps-button-div'
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();

                                                                            window.open(
                                                                                `https://www.google.com/maps/search/?api=1&query=${currentDetector.status.gps_lat},${currentDetector.status.gps_long}`,
                                                                                "_blank",
                                                                                "noopener,noreferrer"
                                                                            );
                                                                        }}
                                                                    >
                                                                        <img src={googleMapsLogo} alt='gmaps' />
                                                                        <p>Google Maps</p>
                                                                    </div>
                                                                </>
                                                            )}

                                                        </div>
                                                    </div>
                                                </Popup>


                                            </Marker>
                                        );
                                    }
                                    return null; // Do not render anything
                                })}

                            </MapContainer>

                            {showDetecPopup && selectedDetector && (
                                <div className="detector-popup-overlay">
                                    <div className="popup-container-wrapper">
                                        <div className="popup-scrollable">
                                            {/* Main Detector Popup */}
                                            <div className={`detector-popup-content ${showNotesPopup ? 'with-notes' : ''}`}>
                                                <button className='close-detector-popup' onClick={() => handleCloseBigPopup()}>x</button>
                                                <img
                                                    src={
                                                        previewURL ||
                                                        (galleryData.find(photo => photo.DETECTOR_ID === selectedDetector.mac)?.DETECTOR_IMG) ||
                                                        fnnPopupLogo
                                                    }
                                                    alt="Detector"
                                                    className={`selected-detector-popup ${showNotesPopup ? 'img-with-notes' : ''}`}
                                                />

                                                <div className='new-popup-info2-wrapper'>
                                                    <h1>
                                                        <span style={{ color: '#28aee1' }}>
                                                            {getDetectorName(selectedDetector.mac, macsFromTailscale)}
                                                        </span>
                                                    </h1>

                                                    <div className='new-popup-info2-and-buttons'>
                                                        <div className='new-popup-info2'>
                                                            <p>
                                                                <strong>Status:</strong>{" "}
                                                                <span style={{ color: selectedDetector.online ? 'green' : 'red' }}>
                                                                    {selectedDetector.online ? 'Online' : 'Offline'}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <strong>Location:</strong> {Number(selectedDetector.status.gps_lat).toFixed(2)} | {Number(selectedDetector.status.gps_long).toFixed(2)}
                                                            </p>

                                                            <div>
                                                                <strong>Image:</strong>
                                                                <input
                                                                    id="detector-image-upload"
                                                                    className="custom-detec-image-input"
                                                                    type="file"
                                                                    name="DETECTOR_IMG"
                                                                    accept="image/*"
                                                                    onChange={(e) => {
                                                                        const file = e.target.files?.[0];
                                                                        if (file) {
                                                                            setSelectedImageFile(file);
                                                                            setPreviewURL(URL.createObjectURL(file));
                                                                        }
                                                                    }}
                                                                />
                                                                <div className="custom-detec-image-upload-wrapper">
                                                                    <label htmlFor="detector-image-upload" className="custom-detec-image-upload">
                                                                        Upload Image
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='buttons-from-popup-info2'>
                                                            <button className='custom-detec-image-upload' onClick={handleImageUpload}>
                                                                Save
                                                            </button>
                                                            <button
                                                                className='custom-detec-image-upload'
                                                                onClick={() => setShowNotesPopup(prev => !prev)}
                                                            >
                                                                Notes
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            {/* Optional: Notes popup, shown side-by-side */}
                                            {showNotesPopup && (
                                                <div className="notes-popup-content">
                                                    <div className="notes-popup-content-title">
                                                        <h1>Detector Notes</h1>
                                                        <FaPlus
                                                            className="add-notes-icon"
                                                            onClick={() => {
                                                                setNoteBeingEdited({
                                                                    NOTE_ID: -1,
                                                                    DETECTOR_ID: selectedDetector.mac,
                                                                    NOTE_TITLE: '',
                                                                    NOTE_SUBMIT_DATE: getTodayDateString(),
                                                                    NOTE_EDIT_DATE: '',
                                                                    NOTE_BODY: '',
                                                                });
                                                                setEditTitle('');
                                                                setEditBody('');
                                                            }}
                                                        />
                                                    </div>

                                                    {noteBeingEdited?.NOTE_ID === -1 && (
                                                        <div className="note-edit-form">
                                                            <div className='inner-note-edit'>
                                                                <h2>Title</h2>
                                                                <input
                                                                    type="text"
                                                                    value={editTitle}
                                                                    onChange={(e) => setEditTitle(e.target.value)}
                                                                    placeholder="Note Title"
                                                                />
                                                            </div>
                                                            {/* <p>
                                                            <strong>Created on:</strong> {noteBeingEdited?.NOTE_SUBMIT_DATE ?? ''}
                                                        </p> */}
                                                            <div>
                                                                <div className='inner-note-edit'>
                                                                    <h2>Note</h2>
                                                                    <textarea
                                                                        className="note-textarea"
                                                                        value={editBody}
                                                                        onChange={(e) => setEditBody(e.target.value)}
                                                                        placeholder="Note Body"
                                                                    ></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="edit-buttons">
                                                                <button
                                                                    onClick={() => {
                                                                        if (!noteBeingEdited) return;

                                                                        if (!editTitle.trim() || !editBody.trim()) {
                                                                            toast.error('Note Title and Body cannot be empty!', {
                                                                                autoClose: 4000,
                                                                                hideProgressBar: false,
                                                                                closeOnClick: true,
                                                                                pauseOnHover: true,
                                                                                draggable: true,
                                                                                style: {
                                                                                    backgroundColor: '#2d2f31',
                                                                                    color: 'white',
                                                                                    fontSize: '16px',
                                                                                },
                                                                            });
                                                                            return;
                                                                        }

                                                                        const { NOTE_ID, ...noteWithoutId } = {
                                                                            ...noteBeingEdited,
                                                                            NOTE_TITLE: editTitle,
                                                                            NOTE_BODY: editBody,
                                                                            NOTE_EDIT_DATE: noteBeingEdited.NOTE_ID === -1 ? null : getTodayDateString(),
                                                                        };

                                                                        createNewRowInDB(noteWithoutId as Omit<DetectorNotes, 'NOTE_ID'>);

                                                                        setNoteBeingEdited(null);
                                                                        setEditTitle('');
                                                                        setEditBody('');
                                                                    }}
                                                                >
                                                                    Save
                                                                </button>

                                                                <button onClick={() => setNoteBeingEdited(null)}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="notes-popup-content-scrollable">
                                                        {listOfNotes
                                                            .filter((note) => note.DETECTOR_ID === selectedDetector.mac)
                                                            .map((note) => (
                                                                <div key={note.NOTE_ID} style={{ width: '100%' }} className='the-overall-note-scroller'>
                                                                    {noteBeingEdited?.NOTE_ID === note.NOTE_ID ? (
                                                                        <div className="note-edit-form">
                                                                            <div className='inner-note-edit'>
                                                                                <h2>Title</h2>
                                                                                <input
                                                                                    type="text"
                                                                                    value={editTitle}
                                                                                    onChange={(e) => setEditTitle(e.target.value)}
                                                                                    placeholder="Note Title"
                                                                                />
                                                                            </div>

                                                                            <div className='notes-date-wrapper'>
                                                                                <p>
                                                                                    <strong>Created on:</strong>{' '}
                                                                                    {noteBeingEdited?.NOTE_SUBMIT_DATE ?? ''}
                                                                                </p>
                                                                                {noteBeingEdited?.NOTE_EDIT_DATE && (
                                                                                    <p>
                                                                                        <strong>Edited on:</strong>{' '}
                                                                                        {noteBeingEdited.NOTE_EDIT_DATE}
                                                                                    </p>
                                                                                )}
                                                                            </div>

                                                                            <div className='inner-note-edit'>
                                                                                <h2>Body</h2>
                                                                                <textarea
                                                                                    className="note-textarea"
                                                                                    value={editBody}
                                                                                    onChange={(e) => setEditBody(e.target.value)}
                                                                                    placeholder="Note Body"
                                                                                ></textarea>
                                                                            </div>

                                                                            <div className="edit-buttons">
                                                                                <button
                                                                                    onClick={() => {
                                                                                        if (!noteBeingEdited || noteBeingEdited.NOTE_ID === undefined) return;

                                                                                        if (!editTitle.trim() || !editBody.trim()) {
                                                                                            toast.error('Note Title and Body cannot be empty!', {
                                                                                                autoClose: 4000,
                                                                                                hideProgressBar: false,
                                                                                                closeOnClick: true,
                                                                                                pauseOnHover: true,
                                                                                                draggable: true,
                                                                                                style: {
                                                                                                    backgroundColor: '#2d2f31',
                                                                                                    color: 'white',
                                                                                                    fontSize: '16px',
                                                                                                },
                                                                                            });
                                                                                            return;
                                                                                        }

                                                                                        const updatedNote: DetectorNotes = {
                                                                                            ...noteBeingEdited,
                                                                                            NOTE_TITLE: editTitle,
                                                                                            NOTE_BODY: editBody,
                                                                                            NOTE_EDIT_DATE: getTodayDateString(),
                                                                                        };

                                                                                        updateRowInDB(noteBeingEdited.NOTE_ID, updatedNote);
                                                                                        setNoteBeingEdited(null);
                                                                                        setEditTitle('');
                                                                                        setEditBody('');
                                                                                    }}
                                                                                >
                                                                                    Save
                                                                                </button>
                                                                                <button
                                                                                    className='delete-note-button'
                                                                                    onClick={() => {
                                                                                        if (!noteBeingEdited || noteBeingEdited.NOTE_ID === undefined) return;

                                                                                        deleteRowFromDB(noteBeingEdited.NOTE_ID);
                                                                                        setNoteBeingEdited(null);
                                                                                    }}
                                                                                >
                                                                                    Delete
                                                                                </button>
                                                                                <button onClick={() => setNoteBeingEdited(null)}>
                                                                                    Cancel
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div
                                                                            className="note-entry"
                                                                            onClick={() => {
                                                                                setNoteBeingEdited(note);
                                                                                setEditTitle(note.NOTE_TITLE);
                                                                                setEditBody(note.NOTE_BODY);
                                                                            }}
                                                                        >
                                                                            <div className="note-title-and-date-map">
                                                                                <h2>{note.NOTE_TITLE}</h2>
                                                                                <div className="note-dates-map">
                                                                                    <div className="date-and-icon-map">
                                                                                        <TbCalendarPlus />
                                                                                        <p>{note.NOTE_SUBMIT_DATE}</p>
                                                                                    </div>
                                                                                    <div className="date-and-icon-map">
                                                                                        {note.NOTE_EDIT_DATE && <MdOutlineEditCalendar />}
                                                                                        <p>{note.NOTE_EDIT_DATE}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <p className="note-body-p">{note.NOTE_BODY}</p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            )}




                                        </div>
                                    </div>
                                </div>
                            )}


                        </div>

                        <div className="arrow-and-dash">

                            <div
                                className={`circle-around-arrow ${!isFormVisible ? 'dash-hidden' : ''}`}
                                onClick={handleToggleForm}
                            >
                                {isFormVisible ? <IoIosArrowDown className="arrow-icon" /> : <IoIosArrowUp className="arrow-icon" />}
                            </div>


                            <div ref={formWrapperRef} className={`my-dash ${isFormVisible ? "visible" : ""}`}>
                                <div className='status-search-tip'>
                                    <div className='title-and-region'>
                                        <h1>Status</h1>

                                        <div className='region-selection-dropdown'>
                                            <select
                                                value={savedGroup || ''}
                                                onChange={(e) => {
                                                    const selected = e.target.value;
                                                    setSavedGroup(selected);
                                                    localStorage.setItem("selectedGroup", selected);
                                                    if (chosenGroupCallback) {
                                                        chosenGroupCallback(selected);
                                                    }

                                                    // Refresh the page to trigger map zoom/update
                                                    window.location.reload();
                                                }}
                                            >
                                                <option value="" disabled>Select Region</option>
                                                {Object.keys(clientPermissionGroups)
                                                    .filter((groupName) => clientPermissionGroups[groupName])
                                                    .map((groupName) => (
                                                        <option key={groupName} value={groupName}>
                                                            {groupName.replace('detectors_', '').replaceAll('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>

                                    </div>
                                    <div className="input-box">
                                        <input
                                            type="text"
                                            name="detec-search"
                                            placeholder="Search Detectors"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <p><strong>Tip</strong>: Click the detector marker and pop-up for additional insights.</p>
                                </div>
                                <div className="online-offline">

                                    <div className={`online-ones ${offlineDetectors.length === 0 ? 'online-alone' : ''}`}>
                                        <h2>Online</h2>
                                        <div className="detec-group">
                                            {filteredOnlineDetectors.map((detector) => {
                                                if (
                                                    detector.status.gps_lat !== null &&
                                                    detector.status.gps_long !== null &&
                                                    Math.abs(Number(detector.status.gps_lat)) > 1e-6 &&
                                                    Math.abs(Number(detector.status.gps_long)) > 1e-6
                                                ) {
                                                    return (
                                                        <p
                                                            key={detector.mac}
                                                            onClick={() => {
                                                                openPopup(detector.mac);
                                                                if (window.innerWidth < 700) {
                                                                    setFormVisible((prev) => !prev);
                                                                    setUserToggled((prev) => !prev);
                                                                }
                                                            }}
                                                        >
                                                            🟢 {getDetectorName(detector.mac, macsFromTailscale)}
                                                        </p>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </div>
                                    </div>

                                    {offlineDetectors.length > 0 &&
                                        <div className='online-ones'>
                                            <h2>Offline</h2>
                                            <div className="detec-group">
                                                {filteredOfflineDetectors.map((detector) => {
                                                    if (
                                                        detector.status.gps_lat !== null &&
                                                        detector.status.gps_long !== null &&
                                                        Math.abs(Number(detector.status.gps_lat)) > 1e-6 &&
                                                        Math.abs(Number(detector.status.gps_long)) > 1e-6
                                                    ) {
                                                        return (
                                                            <p
                                                                key={detector.mac}
                                                                onClick={() => {
                                                                    openPopup(detector.mac);
                                                                    if (window.innerWidth < 700) {
                                                                        setFormVisible((prev) => !prev);
                                                                        setUserToggled((prev) => !prev);
                                                                    }
                                                                }}
                                                            >
                                                                🔴 {getDetectorName(detector.mac, macsFromTailscale)}
                                                            </p>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>

                    </>
                ) : (
                    <div>
                        {loading ? (
                            <>
                                <div>
                                    {/* Your existing structure for loading state */}
                                    <LoadingSpinner />
                                </div>
                            </>
                        ) : (
                            <div className="empty-message">
                                <p>No detectors available in this group.</p>

                                <div className='region-selection-dropdown'>
                                    <select
                                        value={savedGroup || ''}
                                        onChange={(e) => {
                                            const selected = e.target.value;
                                            setSavedGroup(selected);
                                            localStorage.setItem("selectedGroup", selected);
                                            if (chosenGroupCallback) {
                                                chosenGroupCallback(selected);
                                            }

                                            // Refresh the page to trigger map zoom/update
                                            window.location.reload();
                                        }}
                                    >
                                        <option value="" disabled>Select Region</option>
                                        {Object.keys(clientPermissionGroups)
                                            .filter((groupName) => clientPermissionGroups[groupName])
                                            .map((groupName) => (
                                                <option key={groupName} value={groupName}>
                                                    {groupName.replace('detectors_', '').replaceAll('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );

}

export default ClientDashboardMapNew